import { render, staticRenderFns } from "./ArticleLayout.vue?vue&type=template&id=3db30cde&"
import script from "./ArticleLayout.vue?vue&type=script&lang=js&"
export * from "./ArticleLayout.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports